import React, { useState } from 'react'
import { SliderProducts } from './SliderProducts'

export const TabCollection = () => {
    const [tab, settab] = useState(1);
    return (
        <div className='w-full flex justify-center items-center mt-4 group'>
            <div className='w-full px-4 xl:p-0 xl:w-[--page-width] flex flex-col items-center justify-center relative'>
                <div className='flex flex-col w-full items-center justify-center gap-4 mb-4 lg:mb-2 '>
                    <h4 className='text-2xl font-bold'>Danh mục phổ biến</h4>
                    <div className='flex w-full items-center justify-center gap-4'>
                        <button onClick={() => settab(1)} className={`${tab == 1 ? "!bg-[--color-button-2]" : ""} bg-[--color-button-1] w-auto px-4 py-1 rounded-full  text-sm font-bold 
                    transition-all duration-200`}>Các mặt hàng sữa</button>
                        <button onClick={() => settab(2)} className={`${tab == 2 ? "!bg-[--color-button-2]" : ""} bg-[--color-button-1] w-auto px-4 py-1 rounded-full  text-sm font-bold 
                    transition-all duration-200`}>Rau</button>
                        <button onClick={() => settab(3)} className={`${tab == 3 ? "!bg-[--color-button-2]" : ""} bg-[--color-button-1] w-auto px-4 py-1 rounded-full  text-sm font-bold 
                    transition-all duration-200`}>Tiệm bánh</button>
                    </div>
                </div>
                <SliderProducts />
            </div>

        </div>
    )
}
